import Vue from "vue";

export const getContacts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("friend/get_friends")
      .then(call => {
        commit("SET_CONTACTS", call.data);
        resolve(call.data);
      })
      .catch(() => reject());
  });
};
